import { render } from "./UenoRanking.vue?vue&type=template&id=732da0ca&scoped=true&ts=true&lang=pug"
import script from "./UenoRanking.vue?vue&type=script&lang=ts"
export * from "./UenoRanking.vue?vue&type=script&lang=ts"

import "./UenoRanking.vue?vue&type=style&index=0&id=732da0ca&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-732da0ca"]])

export default __exports__